"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocation = getLocation;
exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _server = babelHelpers.interopRequireDefault(require("react-dom/server"));

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var LocationInfo;

function getLocation() {
  if (!LocationInfo) {
    LocationInfo = new Promise(function (resolve) {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', 'data/geoip', true);

      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4) resolve(JSON.parse(xhr.responseText));
      };

      xhr.send();
    });
  }

  return LocationInfo;
}

var Contact =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(Contact, _Component);
  babelHelpers.createClass(Contact, null, [{
    key: "serverRender",
    value: function serverRender(page, defaultPhone) {
      var locationLink = page.getLink('locations');
      return "\n\t\t\t<div data-component=\"Contact\">".concat(_server.default.renderToString(_react.default.createElement(Contact, {
        defaultPhone: defaultPhone,
        locationLink: locationLink
      })), "</div>\n\t\t\t").concat(page.inlineScript("\n\t\t\t\trequire('contact-info').default.clientRender(this.querySelector('[data-component=Contact]'), ".concat(JSON.stringify(defaultPhone), ", ").concat(JSON.stringify(locationLink), ");\n\t\t\t")), "\n\t\t");
    }
  }, {
    key: "clientRender",
    value: function clientRender(node, defaultPhone, link) {
      _reactDom.default.render(_react.default.createElement(Contact, {
        defaultPhone: defaultPhone,
        locationLink: link
      }), node);
    }
  }]);

  function Contact(props) {
    var _this;

    babelHelpers.classCallCheck(this, Contact);
    _this = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(Contact).call(this, props));
    _this.shop = 'https://shop.thepoolandspahouse.com/';
    _this.state = {
      phone: props.defaultPhone
    };
    return _this;
  }

  babelHelpers.createClass(Contact, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      getLocation().then(function (info) {
        if (info.Location) {
          _this2.setState({
            phone: info.Location.phone
          });
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", null, _react.default.createElement("div", {
        className: "contact-container"
      }, _react.default.createElement("p", null, "Call us at ", _react.default.createElement("span", {
        className: "phone"
      }, this.state.phone)), _react.default.createElement("p", {
        className: "pike"
      }, "|"), this.shop && _react.default.createElement(_react.Fragment, null, _react.default.createElement("a", {
        href: this.shop,
        target: "_blank"
      }, _react.default.createElement("p", null, "Shop Online")), _react.default.createElement("p", {
        className: "pike"
      }, "|")), _react.default.createElement("a", {
        href: this.props.locationLink
      }, _react.default.createElement("p", null, "Find a Location"))), _react.default.createElement("div", {
        className: "contact-container-mobile"
      }, _react.default.createElement("p", {
        className: "bold"
      }, "Call us at ", _react.default.createElement("span", {
        className: "phone"
      }, this.state.phone))));
    }
  }]);
  return Contact;
}(_react.Component);

exports.default = Contact;